class VwDatagridpropsDTO {
    id: number = null;
    kullaniciId?: number = null;
    datagridId?: string = "";
    coltext?: string = "";
    colVisibility?: string = "";
    colOrder?: string = "";
};
export default VwDatagridpropsDTO;